module.exports = __webpack_public_path__ + "static/media/vitacura_mobile.b6184cf5.jpg";